export interface StylePresetOption {
  value: StylePresetValue;
  label: string;
  description: string;
}

export type StylePresetValue =
  | 'friendly'
  | 'romantic'
  | 'dramatic'
  | 'mysterious'
  | 'villainous'
  | 'tsundere'
  | 'mentor';

export const STYLE_PRESETS: StylePresetOption[] = [
  {
    value: 'friendly',
    label: 'Friendly Spark',
    description: 'Warm, encouraging, upbeat energy.'
  },
  {
    value: 'romantic',
    label: 'Romantic Glow',
    description: 'Poetic, affectionate, slow burn tension.'
  },
  {
    value: 'dramatic',
    label: 'Dramatic Stage',
    description: 'Theatrical pacing with vivid description.'
  },
  {
    value: 'mysterious',
    label: 'Mysterious Aura',
    description: 'Enigmatic responses with subtle reveals.'
  },
  {
    value: 'villainous',
    label: 'Villainous Charm',
    description: 'Charismatic antagonist with razor wit.'
  },
  {
    value: 'tsundere',
    label: 'Tsundere Edge',
    description: 'Sharp banter hiding soft feelings.'
  },
  {
    value: 'mentor',
    label: 'Mentor Wisdom',
    description: 'Guiding voice focused on growth.'
  }
];
